import styled from 'styled-components'

export const StyledTableOptionsContainer = styled.div`
    position: relative;
    margin-top: 2rem;
    font-weight: 400;
    font-size: 1.4rem;
    color: #545F7D;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .page-number-container {
        display: flex;
        align-items: center;
        gap: 1rem;
    }

    @media(max-width: 730px) {
        flex-direction: column;
        gap: 2rem;
    }
`
export const StyledCustomSelect = styled.label`
    position: relative;
    min-width: 8rem;

    select {
        -webkit-appearance: none;
        border: none;
        padding: 7px 40px 7px 12px;
        width: 100%;
        background-color: rgba(33, 63, 125, 0.1);
        border-radius: 4px;
        cursor: pointer;
        font-family: inherit;
        font-weight: 500;
        font-size: 1.4rem;
        color: #213F7D;
        transition: all 150ms ease;

        &:focus-visible {
            outline: none;
        }
    }

    svg {
        position: absolute;
        right: 1.3rem;
        top: 0.5rem;
    }
`